module.exports = __webpack_public_path__ + "static/media/tini-home.e0e85918.png";